export const IncomingMessageType = {
    EASY_ONBOARDING_BACK_STATE: 'EVENT_EASY_ONBOARDING_BACK',
} as const;

export type IncomingMessageType = (typeof IncomingMessageType)[keyof typeof IncomingMessageType];

export interface MessageEvent {
    data?: {
        type?: string;
    };
}
export type EasyOnboardingBackEvent = MessageEvent & {
    data?: {
        payload?: {
            url?: string;
        };
    };
};
